import DashboardState, { actions } from '@/pages/Dashboard/Dashboard.redux.js';
import { ProfileOutlined, DollarOutlined, FilePdfOutlined } from '@ant-design/icons';
import React, { lazy } from 'react';

import { registerNavigation } from '@/core/navigation';
import { registerReduxStore } from '@/core/store';
import { registerRoutes } from '@/core/routes';

const Dashboard = lazy(() => import('./Dashboard'));
const ViewStatement = lazy(() => import('./ViewStatement'));



registerReduxStore('dashboard', DashboardState, actions);


registerRoutes([
    {
        path:        '/dashboard',
        exact:       true,
        render:      <Dashboard />,
        title:       'Contacts & Addresses',
        private:     true,
        permissions: [],
    },
    {
        path:        '/dashboard/statement',
        exact:       true,
        render:      <ViewStatement />,
        title:       'View Statement',
        private:     true,
        permissions: [],
    },
]);



registerNavigation({
    title:       'Account Details',
    permissions: [],
    single:      false,
    top:         true,
    home:        true,
    icon:        <DollarOutlined />,
    children:    [
        {
            title:       'Contacts & Addresses',
            url:         '/dashboard',
            icon:        <ProfileOutlined />,
            permissions: [],
        },
        {
            title:       'View Statement',
            url:         '/dashboard/statement',
            icon:        <FilePdfOutlined />,
            permissions: [],
        },
    ],
});


console.log('Registered Dashboard Plugin');